import { render, staticRenderFns } from "./AccountSettingMFA.vue?vue&type=template&id=21bc6312&"
import script from "./AccountSettingMFA.vue?vue&type=script&lang=js&"
export * from "./AccountSettingMFA.vue?vue&type=script&lang=js&"
import style0 from "./AccountSettingMFA.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports